<h1 mat-dialog-title>Server Error</h1>
<div mat-dialog-content>
    <p>{{message}}</p>
</div>
<div mat-dialog-actions>
    <button mat-button
        class="bk-button"
        (click)="close()">Continue</button>
</div>
